import { component } from 'picoapp'
import { getSizedImageUrl, imageSize } from '@/lib/images.js'
import { formatMoney } from '@/lib/currency.js'
import app from '@/app.js'

const X = `<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentcolor" stroke-width="3" style="display:inline-block;vertical-align:middle;overflow:visible;"><path d="M1.0606601717798212 1.0606601717798212 L14.939339828220179 14.939339828220179"></path><path d="M14.939339828220179 1.0606601717798212 L1.0606601717798212 14.939339828220179"></path></svg>`

function createItem ({
  variant_id: id,
  product_title: title,
  line_price: price,
  variant_title: color,
  image,
  url,
  quantity,
  ...item
}) {
  const img = image ? getSizedImageUrl(
    image.replace('.' + imageSize(image), ''), '200x' // TODO hacky af
  ) : 'https://cdn.shopify.com/s/files/1/0039/2685/1651/files/zoe-schaeffer-u7POlmef6lU-unsplash_1.jpg?v=1599089046'

  return `
<div class='cart-drawer__item py-4 border-b border-light-gray' data-component='cartDrawerItem' data-id=${id}>
  <div class='flex w-full'>
    <div>
      <a href='${url}' class='w-16'>
        <img src='${img}' />
      </a>
    </div>
    <div class='flex-auto'>
      <div class='px-6'>
        <div class='mb-1 text-sm'>
          <a href='${url}' class='leading-normal'>${title}</a>
        </div>
        <div class='mb-1 text-gray text-xs'>
          ${color ? `<span>${color.split(':')[0]}</span>` : ``}
        </div>
        <div class='mb-4 text-sm'>${formatMoney(price)}</div>
        <div class='flex justify-end w-full items-center text-xs'>
          <div class='inline-block mr-3'>
            <div class='flex items-center border border-light-gray py-1'>
              <div class='cart-quantity js-remove-single px-2'>-</div>
              <div class='js-single-quantity px-2'>${quantity}</div>
              <div class='cart-quantity js-add-single px-2'>+</div>
            </div>
          </div>
          <div>
            <button class='button--reset js-remove-item underline text-gray'>Remove</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
}

function renderItems (items) {
  return items.length > 0 ? (
    items.reduce((markup, item) => {
      markup += createItem(item)
      return markup
    }, '')
  ) : (
    `<div class='pv1'><p class='pv1 mv05 sans small cm i ac'>Your cart is empty</p></div>`
  )
}

export default component((node, ctx) => {
  const closeButton = node.querySelector('.js-close')
  const subtotal = node.querySelector('.js-subtotal')
  const count = node.querySelector('.js-count')
  const itemsRoot = node.querySelector('.js-items')
  const loading = itemsRoot.innerHTML

  const render = (cart) => {
    itemsRoot.innerHTML = renderItems(cart.items)

    let quantity = 0;    

    for (let i = 0; i < cart.items.length; i++) {
      quantity = cart.items[i].quantity + quantity
    }

    count.innerHTML = quantity

    subtotal.innerHTML = formatMoney(cart.total_price)
  }

  const open = (cart) => {
    itemsRoot.innerHTML = loading
    setTimeout(() => {
      document.body.classList.add('cart--open')
      setTimeout(render(cart), 10)
      app.mount()
    }, 50)
  }

  const close = () => {
    setTimeout(() => {
      document.body.classList.remove('cart--open')
      app.hydrate({cartOpen: false})
    }, 50)
  }

  render(ctx.getState().cart)

  closeButton.addEventListener('click', close)

  ctx.on('cart:toggle', ({ cart, cartOpen }) => {
    cartOpen && open(cart)
  })
  ctx.on('cart:updated', () => {
    render(ctx.getState().cart)
    app.mount()
  })
})
